// extracted by mini-css-extract-plugin
export default {"radio":"_2V2AlgeU","label":"_1dM16HHh","selected":"PqZCLnPi","disabled":"_1_H4b0fp"};